"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NIGHT_WORD_FORMS = exports.NDASHS = exports.NBSP = exports.SKELETON_ANIMATION_DURATION = exports.SKELETON_ANIMATION_DELAY = exports.INSTANT_CONFIRM_HINT_TEXT = exports.HOT_PRICE_HINT_TEXT = exports.DATE_FULL_DATE = exports.DATE_FORMAT_WITH_DAY_OF_WEEK = exports.DATE_FORMAT_CLIENT = void 0;

var _localization = require("@lt/localization");

/**
 * дата в формате 02.01.2019
 */
var DATE_FORMAT_CLIENT = 'dd.MM.yyyy';
/**
 * дата в формате 28 мая, пт
 */

exports.DATE_FORMAT_CLIENT = DATE_FORMAT_CLIENT;
var DATE_FORMAT_WITH_DAY_OF_WEEK = 'd MMM, EEEEEE';
/**
 * дата в формате 2 янв 2019 в 12:50
 */

exports.DATE_FORMAT_WITH_DAY_OF_WEEK = DATE_FORMAT_WITH_DAY_OF_WEEK;
var DATE_FULL_DATE = 'd MMM yyyy в HH:mm';
exports.DATE_FULL_DATE = DATE_FULL_DATE;

var HOT_PRICE_HINT_TEXT = _localization.i18n.t('hotel.offer.hotPrice');

exports.HOT_PRICE_HINT_TEXT = HOT_PRICE_HINT_TEXT;

var INSTANT_CONFIRM_HINT_TEXT = _localization.i18n.t('hotel.offer.instant');

exports.INSTANT_CONFIRM_HINT_TEXT = INSTANT_CONFIRM_HINT_TEXT;
var SKELETON_ANIMATION_DELAY = 300; // ms

exports.SKELETON_ANIMATION_DELAY = SKELETON_ANIMATION_DELAY;
var SKELETON_ANIMATION_DURATION = 1200; // ms

exports.SKELETON_ANIMATION_DURATION = SKELETON_ANIMATION_DURATION;
var NBSP = String.fromCharCode(160);
exports.NBSP = NBSP;
var NDASHS = '-';
exports.NDASHS = NDASHS;
var NIGHT_WORD_FORMS = [_localization.i18n.t('hotel.offer.night', {
  count: 0
}), _localization.i18n.t('hotel.offer.night', {
  count: 1
}), _localization.i18n.t('hotel.offer.night', {
  count: 2
})];
exports.NIGHT_WORD_FORMS = NIGHT_WORD_FORMS;